import { Process } from '../../apis/digital-process.model';
import { RouteStep } from '../../apis/onboarding-process.model';
import {
	OnboardingProcess,
	StepRouteProgress,
} from '../../state/onboarding-process-state.model';

export const mapFromStepRouteObject = (
	object: Object
): Array<OnboardingProcess> => {
	if (object === null || object === undefined) {
		throw new Error(`Invalid object, object is ${object}`);
	}
	return Object.entries(object).map(entry => {
		const [stepNumber, routeSteps] = entry;
		return getOnboardingProgres(Number(stepNumber), routeSteps);
	});
};

export const getOnboardingProgres = (
	stepNumber: number,
	routeSteps: Array<RouteStep>
): OnboardingProcess => {
	if (stepNumber < 0) {
		throw new Error('Invalid stepNumber, stepNumber is negative');
	}

	return {
		stepNumber: stepNumber,
		isCompleted: false,
		stepRoutesProgress: mapStepRoutesProgressFrom(routeSteps),
	};
};

export const mapStepRoutesProgressFrom = (
	routesSteps: Array<RouteStep>
): Array<StepRouteProgress> => {
	if (routesSteps === null || routesSteps === undefined) {
		throw new Error(`Invalid routesSteps, routesSteps: ${routesSteps}`);
	}
	if (routesSteps.length === 0) {
		throw new Error('RoutesSteps is empty');
	}
	return routesSteps.map(stepRoute => mapStepRouteProgressFrom(stepRoute));
};

export const mapStepRouteProgressFrom = (
	stepRoute: RouteStep
): StepRouteProgress => {
	if (stepRoute === null || stepRoute === undefined) {
		throw new Error(`Invalid RouteStep, routeStep: ${stepRoute}`);
	}
	return {
		route: stepRoute.ruta,
		isCompleted: false,
		wasSkipped: false,
		canGoBack: stepRoute.retroceso,
		isRequired: stepRoute.requerido,
		stepRouteNumber: stepRoute.orden,
		routeName: stepRoute.nombre_ruta ?? 'SN',
	};
};

export const mapFromDigitalProcessList = (
	processes: Array<Process>
): Array<OnboardingProcess> => {
	if (processes === null || processes === undefined) {
		throw new Error(`processes is ${processes}`);
	}
	if (processes.length === 0) {
		throw new Error(`processes is empty`);
	}
	return mapFromStepRouteObject(groupStepProcess(processes));
};

export const groupStepProcess = (processes: Array<Process>): Object => {
	if (processes === null || processes === undefined) {
		throw new Error(`processes is ${processes}`);
	}
	const group = processes.reduce((processGroup, process) => {
		const key = process.id_paso.toString();
		const { ruta, orden, requerido, retroceso, titulo_proceso } = process;
		const routeStep: RouteStep = {
			ruta,
			orden,
			requerido,
			retroceso,
			nombre_ruta: titulo_proceso,
		};
		processGroup[key] = processGroup[key] ?? [];
		processGroup[key].push(routeStep);
		return processGroup;
	}, {});
	return group;
};
